<template>
  <div class="country-switch--wrap">
    <v-menu>
      <template #activator="{ props }">
        <div v-bind="props">
          <v-sheet v-if="large">
            <v-btn
              prepend-icon="public"
              append-icon="arrow_drop_down"
              size="large"
              color="primary"
              elevation="0"
            >
              {{ currentLocale?.label }}
            </v-btn>
          </v-sheet>

          <v-btn
            v-else
            icon="public"
          />
        </div>
      </template>
      <v-list class="py-0">
        <v-list-item
          v-for="locale in locales"
          :key="locale.code"
          :active="currentLocale.locale === locale.locale"
          @click="setLocale(locale)"
        >
          <v-list-item-title>{{ locale.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'

import { locales, useLocaleStore } from '@/stores/locale.js'

export default {
  props: {
    large: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      locales
    }
  },

  computed: {
    ...mapState(useLocaleStore, ['currentLocale', 'currency']),
  },

  methods: {
    ...mapActions(useLocaleStore, ['setLocale']),
  },
}
</script>
